<modal
  [config]="viewDetailsModalConfig"
  [condition]="true"
  (cancel)="closeDetailsModal()"
>
  <div body>
    @for (benefit of plan?.formattedBenefits; track benefit; let i = $index) {
      <div class="ModalCard__RowDetail">
        @if (benefit.label) {
          <p
            class="t-data t-bold"
            [innerHTML]="benefit.label"
            [data-test-id]="'benefitLabel_' + i"
          ></p>
        }
        @if (benefit.value) {
          <p
            class="t-data"
            [innerHTML]="benefit.value"
            [data-test-id]="'benefitValue_' + i"
          ></p>
        }
      </div>
    }

    @if (
      planDetailConfigs?.displayAllDocuments ||
      planDetailConfigs?.displayDocuments
    ) {
      <div>
        <div class="ModalCard__Pdf">
          @for (document of documentList; track document; let i = $index) {
            <div>
              <a
                class="ModalCard__DocumentLink"
                [href]="document.document_id"
                target="_blank"
              >
                <icon
                  name="pdf"
                  [config]="{ type: 'link' }"
                  [data-test-id]="'documentIcon_' + i"
                ></icon>
                <span
                  class="t-data t-bold"
                  [innerHTML]="
                    document.label || formatDocumentName(document.type)
                  "
                  [data-test-id]="'documentLabel_' + i"
                ></span>
              </a>
            </div>
          }
        </div>
      </div>
    } @else {
      @if (!!pdfUrl) {
        <div class="ModalCard__Pdf">
          <a class="ModalCard__DocumentLink" [href]="pdfUrl" target="_blank">
            <icon
              name="pdf"
              [config]="{ type: 'link' }"
              data-test-id="planPdfIcon"
            ></icon>
            <span
              class="t-data t-bold"
              [innerHTML]="'All ' + plan?.display_name + ' Benefits'"
              data-test-id="allPlanDisplayName"
            ></span>
          </a>
        </div>
      }
    }
  </div>
</modal>
